import cn from 'classnames';
import { contactIconsMap, type ContactType } from '@widgets/contacts/contact-edit/constans.tsx';
import { isPhoneNumber } from '@shared/helpers';
import { type ContactItem } from '@shared/types/contacts';
import * as st from './styles.module.scss';

interface Props {
  contacts: ContactItem[];
  isSpecialist?: boolean;
}

export const Contacts: React.FC<Props> = ({ contacts, isSpecialist }) => {
  return (
    <div>
      {!isSpecialist && <div className={st.title}>Контакты</div>}
      <ul className={st.contactList}>
        {contacts.map((contact) => {
          const hrefValue = isPhoneNumber(contact.value)
            ? contact.value.replace(/ /g, '').replace(/-/g, '')
            : contact.value;
          const contactValue = isPhoneNumber(contact.value) ? `+ ${contact.value}` : contact.value;
          return (
            <li key={contact.id} title={contact.value}>
              <a
                className={st.contactList__item}
                href={`${contact.base_url}${hrefValue}`}
                target="_blank"
                rel="noreferrer"
              >
                <span
                  className={cn(
                    st.icon,
                    // contact.type === 'phone' && st.phone,
                    // contact.type === 'skype' && st.skype
                  )}
                >
                  {contactIconsMap[contact.type as ContactType]}
                </span>
                <span className={st.value}>{contactValue}</span>
              </a>
            </li>
          );
        })}
      </ul>
    </div>
  );
};
